import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAdminAuth } from '../context/AdminAuthContext';
import './Sidebar.css';

interface NavItem {
  to: string;
  label: string;
  icon: React.ReactNode;
}

const iconProps = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.8,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
};

const NAV_ITEMS: NavItem[] = [
  {
    to: '/rj/admin/dashboard',
    label: 'Dashboard',
    icon: (
      <svg {...iconProps}>
        <rect x="3" y="3" width="7" height="9" rx="1.5" />
        <rect x="14" y="3" width="7" height="5" rx="1.5" />
        <rect x="14" y="12" width="7" height="9" rx="1.5" />
        <rect x="3" y="16" width="7" height="5" rx="1.5" />
      </svg>
    ),
  },
  {
    to: '/rj/censo-presencial',
    label: 'Censo Online',
    icon: (
      <svg {...iconProps}>
        <rect x="3" y="4" width="18" height="12" rx="2" />
        <line x1="8" y1="20" x2="16" y2="20" />
        <line x1="12" y1="16" x2="12" y2="20" />
      </svg>
    ),
  },
  {
    to: '/rj/admin/censo',
    label: 'Censo Presencial',
    icon: (
      <svg {...iconProps}>
        <path d="M12 21s-7-7.5-7-12a7 7 0 1 1 14 0c0 4.5-7 12-7 12z" />
        <circle cx="12" cy="9" r="2.5" />
      </svg>
    ),
  },
];

const SUPER_ADMIN_ITEMS: NavItem[] = [
  {
    to: '/rj/admin/polos',
    label: 'Gerenciamento de Polos',
    icon: (
      <svg {...iconProps}>
        <path d="M3 21V8l9-5 9 5v13" />
        <path d="M9 21v-7h6v7" />
      </svg>
    ),
  },
  {
    to: '/rj/admin/register',
    label: 'Registrar Admin',
    icon: (
      <svg {...iconProps}>
        <circle cx="9" cy="8" r="3.5" />
        <path d="M3 20c0-3.3 2.7-6 6-6s6 2.7 6 6" />
        <line x1="18" y1="9" x2="18" y2="15" />
        <line x1="15" y1="12" x2="21" y2="12" />
      </svg>
    ),
  },
];

interface SidebarProps {
  onNavigate?: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ onNavigate }) => {
  const { userLevel } = useAdminAuth();
  const items = userLevel === 'super_admin' ? [...NAV_ITEMS, ...SUPER_ADMIN_ITEMS] : NAV_ITEMS;

  return (
    <nav className="sidebar">
      <img src="/PREV logo v2[1]_page-0001.jpg" alt="PREV Logo" className="sidebar__logo" />
      <ul className="sidebar__nav">
        {items.map((item) => (
          <li key={item.to}>
            <NavLink
              to={item.to}
              onClick={onNavigate}
              className={({ isActive }) => `sidebar__link ${isActive ? 'active' : ''}`}
            >
              <span className="sidebar__link-icon" aria-hidden="true">
                {item.icon}
              </span>
              <span className="sidebar__link-label">{item.label}</span>
            </NavLink>
          </li>
        ))}
      </ul>
      <div className="sidebar__footer">
        <span className="sidebar__footer-dot" aria-hidden="true" />
        Console administrativo
      </div>
    </nav>
  );
};

export default Sidebar;
